// extracted by mini-css-extract-plugin
module.exports = {"sumsub":"style_sumsub__2jMry","sslNotice":"style_sslNotice__1IeZA","sslIcon":"style_sslIcon__2SM8l"};